<template>
  <tr :class="classObject()" @click="toggleSelected">
    <td class="col-name">
      <div v-if="!isEdited()"><TooltipEllipses :value="cart.name" /></div>
      <form v-if="isEdited()">
        <input
          @click.stop
          @blur="updateCart()"
          @keyup.enter="updateCart()"
          type="text"
          ref="name"
          :value="cart.name"
          class="form-control"
          v-focus
        />
      </form>
    </td>
    <td class="col-created">{{ formattedDate(cart.created_at) }}</td>
    <td class="col-updated">{{ formattedDate(cart.updated_at) }}</td>
    <td class="col-length">{{ cart.es_count }}</td>
    <td class="col-linked col-length">
      <i class="icon-notice" v-if="cart.text_note"></i>
      <span class="note-status" v-if="textNoteStatusPresent" v-b-tooltip :title="textNoteStatus(cart.text_note)">{{
        textNoteStatus(cart.text_note, true)
      }}</span>
    </td>
    <td class="col-shared col-length">
      <i class="icon-Share_intern" v-if="cart.collaborators.length >= 1"></i>
    </td>
    <td class="col-actions" align="right">
      <CartActions :cart="cart" v-on:edit="onEdit" v-on:sendCart="onSendCart" :sendCartOpen="sendCartOpen()" />

      <CartSend ref="sendCartForm" :cart="cart" v-on:sendCart="onSendCart" v-if="sendCartOpen()" />
    </td>
  </tr>
</template>

<script>
import CartActions from './CartActions.vue';
import CartSend from './CartSend.vue';
import TooltipEllipses from './TooltipEllipses.vue';
import dayjs from 'dayjs';
import { mapState, mapMutations } from 'vuex';
import Vue from 'vue';
import textNoteStatusMixin from 'mixins/textNoteStatusMixin.js';

export default {
  name: 'Cart',
  components: { CartActions, CartSend, TooltipEllipses },
  mixins: [textNoteStatusMixin],
  props: {
    cart: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('carts', ['selectedCartId', 'editCartId']),
    textNoteStatusPresent() {
      const { status } = this.cart.text_note || {};

      return status;
    },
  },
  methods: {
    ...mapMutations('carts', ['assign']),
    isSelected() {
      return this.selectedCartId === this.cart.id;
    },
    isEdited() {
      return this.editCartId === this.cart.id;
    },
    classObject() {
      return {
        'row-marked': this.isSelected() && !this.isEdited(),
        'row-selected': this.isSelected() && this.isEdited(),
      };
    },
    updateCart() {
      this.$store.dispatch('carts/update', { cartId: this.cart.id, data: { name: this.$refs.name.value } });
      this.clear();
    },
    formattedDate(date) {
      return dayjs(date).format('DD-MM-YYYY | HH:mm:ss');
    },
    toggleSelected() {
      this.sendCart = false;

      if (this.isSelected()) {
        this.clear();
      } else {
        this.assign({ name: 'selectedCartId', data: this.cart.id });
        this.assign({ name: 'editCartId', data: null });
      }
    },
    onEdit() {
      if (this.isEdited()) {
        this.clear();
        this.sendCart = false;
      } else {
        this.assign({ name: 'selectedCartId', data: this.cart.id });
        this.assign({ name: 'editCartId', data: this.cart.id });
        this.sendCart = false;
      }
    },
    onSendCart(value) {
      if (value) {
        this.assign({ name: 'selectedCartId', data: this.cart.id });
        this.sendCart = true;
      } else {
        this.sendCart = false;
        this.assign({ name: 'selectedCartId', data: null });
      }
    },
    sendCartOpen() {
      return this.sendCart && this.isSelected();
    },
    clear() {
      this.assign({ name: 'selectedCartId', data: null });
      this.assign({ name: 'editCartId', data: null });
    },
  },
  data() {
    return {
      sendCart: false,
    };
  },
};
</script>
